<template>
    <div class="menu-bar">
        <van-tabbar v-model="active" active-color="lightgray;" inactive-color="#6685a4;" >
            <van-tabbar-item name="home" icon="apps-o" to="/Home/HomeMenuTh">提货服务</van-tabbar-item>
            <!--<van-tabbar-item name="search" icon="search" to="/Home/SearchTh">查询</van-tabbar-item>-->
            <van-tabbar-item name="user" icon="user-o" to="/Home/UserTh">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import { Tabbar, TabbarItem } from 'vant';

  export default {
    name: 'tab-bar',
    components:{
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem,
    },
    data(){
      return {
          active: 'home',
      }
    },
    methods:{

    },
    props: {
      msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .menu-bar{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    /*background: #2c3e50;*/
  }
    .menu-font{
        font-size: 20px;
        font-weight: bolder;
    }


  /deep/ .van-tabbar-item--active {
      color: #6685a4 !important;
  }
  .van-tabbar-item {
      color: darkgray;
  }
</style>
